import { Injectable } from '@angular/core';
import { PaymentMethod } from '@shared/constants/payment-method';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class GetPaymentMethodNameService {
  constructor(private translate: TranslateService) {}
  public getFriendlyMethodPaymentName(method: PaymentMethod): string {
    switch (method) {
      case PaymentMethod.BANK_TRANSFER:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.BANK_TRANSFER');
      case PaymentMethod.CASH:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.CASH');
      case PaymentMethod.CREDIT_CARD:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.CREDIT_CARD');
      case PaymentMethod.DIRECT_DEBIT:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.DIRECT_DEBIT');
      case PaymentMethod.OTHER:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.OTHER');
      case PaymentMethod.PAYMEFY:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.PAYMEFY');
      default:
        return this.translate.instant('DATA.COMMON.PAYMENT_METHODS.UNKNOWN');
    }
  }
}
